/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Typography } from '@mui/material'
import S3Image from '../../S3Image'
import { type location, type ISD } from '../../../core/types'
import { LocationDisplay } from '../LocationCard/LocationDisplay'
import { LargeCard } from '../Large'

export function IsdCardDisplay (props: { isd: ISD }): JSX.Element {
  return <LargeCard header={props.isd.name} content={<>
    {props.isd.logoKey !== null && (
      <S3Image imageKey={props.isd.logoKey ?? 'none'} alt='ISD Logo' />
    )}
    <Typography>{props.isd.notes}</Typography>
    <LocationDisplay location={{
      address: props.isd.address,
      apartment: '',
      city: props.isd.city,
      state: props.isd.state,
      zipCode: props.isd.zipCode,
      isPrimary: false
    } as location}
    />

  </>}
  />
}
